// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"I7FaR","trackingLink":"_57tlW","noData":"_8V8ZB","link":"_1G9YL"};